export class BasicEngineThruster {

    public uid: string;
    public engineThruster: string;
}
